import { GetNetworkQuery } from '@coris-ts/repository/query/network.query'
import type { HttpParameters } from '@coris-ts/data/parameter-type'
import { ApiEndpoint } from '../../../../shared/api-endpoint'
import type { Resolution } from '../../domain/models/range'

export class GetSubscriberIntervalsQuery extends GetNetworkQuery {
  constructor(
    private readonly fromDate: string,
    private readonly toDate: string,
    private readonly resolution: Resolution,
    private readonly organization: string
  ) {
    super(ApiEndpoint.RevenueMRRIntervals)
  }

  public get queryParameters(): HttpParameters {
    return {
      from_date: this.fromDate,
      to_date: this.toDate,
      resolution: this.resolution,
      organization: this.organization
    }
  }
}
